"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var valueOrDefault = function (props, styleFunc, contrastStyleFunc) {
    var ret;
    if (props.contrast && contrastStyleFunc) {
        ret =
            contrastStyleFunc(props.theme.button[props.variant || 'default']) ||
                contrastStyleFunc(props.theme.button.default);
    }
    if (!ret) {
        ret =
            styleFunc(props.theme.button[props.variant || 'default']) ||
                styleFunc(props.theme.button.default);
    }
    return ret;
};
var toHexIfDefined = function (c) {
    return c ? c.hex : undefined;
};
// todo: consider converting to use https://www.npmjs.com/package/styled-components-modifiers
// eslint-disable-next-line @typescript-eslint/no-unused-vars
exports.Button = styled_components_1.default(function (_a) {
    var variant = _a.variant, props = __rest(_a, ["variant"]);
    return React.createElement(antd_1.Button, __assign({}, props));
}).attrs(function (props) { return ({
    // only supporting types that we have styled
    // if the user wants an unsupported type, they should use Ant.Button directly
    type: !props.variant || props.variant === 'primary' || props.variant === 'link'
        ? props.variant
        : 'default'
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    && {\n        line-height: inherit;\n        height: auto;\n        font-weight: ", ";\n        text-transform: ", ";\n        background: ", ";\n        border: ", ";\n        padding: ", ";\n        &,\n        svg,\n        path {\n            color: ", ";\n            transition: color 0ms ease-in-out;\n        }\n\n        &:hover {\n            background: ", ";\n            border: ", ";\n            padding: ", ";\n            &,\n            svg,\n            path {\n                color: ", ";\n                transition: color 0ms ease-in-out;\n            }\n        }\n\n        &:focus {\n            border: ", ";\n            padding: ", ";\n            &,\n            svg,\n            path {\n                color: ", ";\n            }\n        }\n\n        &:disabled {\n            opacity: ", ";\n            background: ", ";\n            border: ", ";\n            padding: ", ";\n            &,\n            svg,\n            path {\n                color: ", ";\n            }\n        }\n    }\n"], ["\n    && {\n        line-height: inherit;\n        height: auto;\n        font-weight: ", ";\n        text-transform: ", ";\n        background: ", ";\n        border: ",
    ";\n        padding: ",
    ";\n        &,\n        svg,\n        path {\n            color: ",
    ";\n            transition: color 0ms ease-in-out;\n        }\n\n        &:hover {\n            background: ",
    ";\n            border: ",
    ";\n            padding: ",
    ";\n            &,\n            svg,\n            path {\n                color: ",
    ";\n                transition: color 0ms ease-in-out;\n            }\n        }\n\n        &:focus {\n            border: ",
    ";\n            padding: ",
    ";\n            &,\n            svg,\n            path {\n                color: ",
    ";\n            }\n        }\n\n        &:disabled {\n            opacity: ", ";\n            background: ",
    ";\n            border: ",
    ";\n            padding: ",
    ";\n            &,\n            svg,\n            path {\n                color: ",
    ";\n            }\n        }\n    }\n"])), function (props) { return valueOrDefault(props, function (b) { return b.fontWeight; }); }, function (props) { return valueOrDefault(props, function (b) { return b.textTransform; }); }, function (props) { return toHexIfDefined(valueOrDefault(props, function (b) { return b.background; })); }, function (props) {
    return valueOrDefault(props, function (b) { return b.border; }, function (b) { return b.contrastBorder; });
}, function (props) {
    return valueOrDefault(props, function (b) { return b.paddingVertical; }) + "\n                " + valueOrDefault(props, function (b) { return b.paddingHorizontal; });
}, function (props) {
    return toHexIfDefined(valueOrDefault(props, function (b) { return b.color; }, function (b) { return b.contrastColor; }));
}, function (props) {
    return toHexIfDefined(valueOrDefault(props, function (b) { return b.hover.background; }, function (b) { return b.hover.contrastBackground; }));
}, function (props) {
    return valueOrDefault(props, function (b) { return b.hover.border; }, function (b) { return b.hover.contrastBorder; });
}, function (props) {
    return valueOrDefault(props, function (b) { return b.hover.paddingVertical; }) + "\n                    " + valueOrDefault(props, function (b) { return b.hover.paddingHorizontal; });
}, function (props) {
    return toHexIfDefined(valueOrDefault(props, function (b) { return b.hover.color; }, function (b) { return b.hover.contrastColor; }));
}, function (props) {
    return valueOrDefault(props, function (b) { return b.focus.border; }, function (b) { return b.focus.contrastBorder; });
}, function (props) {
    return valueOrDefault(props, function (b) { return b.focus.paddingVertical; }) + "\n                    " + valueOrDefault(props, function (b) { return b.focus.paddingHorizontal; });
}, function (props) {
    return toHexIfDefined(valueOrDefault(props, function (b) { return b.focus.color; }, function (b) { return b.focus.contrastColor; }));
}, function (props) { return valueOrDefault(props, function (b) { return b.disabled.opacity; }); }, function (props) {
    return toHexIfDefined(valueOrDefault(props, function (b) { return b.disabled.background; }, function (b) { return b.disabled.contrastBackground; }));
}, function (props) {
    return valueOrDefault(props, function (b) { return b.disabled.border; }, function (b) { return b.disabled.contrastBorder; });
}, function (props) {
    return valueOrDefault(props, function (b) { return b.disabled.paddingVertical; }) + "\n                    " + valueOrDefault(props, function (b) { return b.disabled.paddingHorizontal; });
}, function (props) {
    return toHexIfDefined(valueOrDefault(props, function (b) { return b.disabled.color; }, function (b) { return b.disabled.contrastColor; }));
});
var templateObject_1;
//# sourceMappingURL=button.js.map